import BaseModelAPI from '../BaseModelAPI';

export default class ControlCard extends BaseModelAPI {
	static entity = 'controlcard';
	static entityName = 'controlcard';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.controlCardNumber = '';
		this.id = '';
		this.controlCardTypeId = '';
		this.controlCardType = {};
		this.partId = '';
		this.part = {};
		this.qtyCase = 0;
		this.areaId = '';
		this.area = {};
		this.rackId = '';
		this.rack = {};
		this.docNo = '';
		this.status = '';
		this.receivingDate = '';
		this.transactionType = '';
		this.transactionId = '';
		this.revisi = 0;
		this.packSequence = 0;
		this.totalPack = 0;
		this.controlCardStatusId = '';
		this.controlCardStatus = {};
		this.qcStatusId = '';
		this.qcStatus = {};
		this.originalControlCardId = '';
		this.originalControlCard = {};
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async printControlCard(this_, ids) {
		return await this_.$http.post(`${this.entityName}/printControlCard/`, ids)
			.then(function (response) {
				if (response == null) {
					this.toast({ message: 'Gagal melakukan Print', title: 'Error', variant: 'danger', autoHideDelay: 3000 });
					return;
				}
				return response;
			}).catch(error => {
				var stringError = 'Gagal melakukan Print';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError = errorObj[0];
				}
				this.toast({ message: stringError, title: 'Error', variant: 'danger', autoHideDelay: 3000 });
				// this.$store.dispatch('addErrorMessageGlobal', error);
				this.isBusy = false;
			});
	}
}